export enum InvoiceStatus {
    Pending = 'pending',
    Eligible = 'eligible',
    Confirmed = 'confirmed',
    Assigned = 'assigned',
    PartiallyPaid = 'partially-paid',
    Charged = 'charged',
    Refunded = 'refunded',
    Canceled = 'canceled',
    Expired = 'expired',
    Overdue = 'overdue',
    Defaulted = 'defaulted',
}
